/** Modo de vista — Atención a clientes (reversible sin tocar otros módulos). */

export const CLIENTES_VIEW_WHATSAPP_EMBED = "whatsapp_embed";
export const CLIENTES_VIEW_LEGACY_MOCK = "legacy_mock";

export const CLIENTES_ATENCION_VIEW_STORAGE_KEY = "visor:clientes_atencion_view";

export const WHATSAPP_WEB_OFFICIAL_URL = "https://web.whatsapp.com/";

export function readClientesAtencionViewMode() {
  if (typeof window === "undefined") return CLIENTES_VIEW_WHATSAPP_EMBED;
  try {
    const raw = window.localStorage.getItem(CLIENTES_ATENCION_VIEW_STORAGE_KEY);
    if (raw === CLIENTES_VIEW_LEGACY_MOCK) return CLIENTES_VIEW_LEGACY_MOCK;
    return CLIENTES_VIEW_WHATSAPP_EMBED;
  } catch {
    return CLIENTES_VIEW_WHATSAPP_EMBED;
  }
}

export function writeClientesAtencionViewMode(mode) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      CLIENTES_ATENCION_VIEW_STORAGE_KEY,
      mode === CLIENTES_VIEW_LEGACY_MOCK ? CLIENTES_VIEW_LEGACY_MOCK : CLIENTES_VIEW_WHATSAPP_EMBED,
    );
  } catch {
    // ignore quota / private mode
  }
}

export function isWhatsAppEmbedViewMode(mode) {
  return mode !== CLIENTES_VIEW_LEGACY_MOCK;
}
